var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 209,
    height: 278,
    viewBox: "0 0 209 278",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H112.706C123.751 0 132.706 8.95431 132.706 20V37.5V63.5C132.706 74.5457 141.66 83.5 152.706 83.5H175.708H189C200.046 83.5 209 92.4543 209 103.5V258C209 269.046 200.046 278 189 278H20C8.9543 278 0 269.046 0 258V20Z",
    fill: "url(#paint0_linear_7_4)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0H112.706C123.751 0 132.706 8.95431 132.706 20V37.5V63.5C132.706 74.5457 141.66 83.5 152.706 83.5H175.708H189C200.046 83.5 209 92.4543 209 103.5V258C209 269.046 200.046 278 189 278H20C8.9543 278 0 269.046 0 258V20Z",
    fill: "url(#paint1_linear_7_4)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M141 13L194 76H156C147.716 76 141 69.2843 141 61V13Z",
    fill: "#1890FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M104 233.8C93.2 233.8 84.0667 231 76.6 225.4C69.2667 219.8 63.6667 211.667 59.8 201C56.0667 190.2 54.2 177 54.2 161.4C54.2 145.533 56.0667 132.267 59.8 121.6C63.6667 110.933 69.2667 102.867 76.6 97.4C84.0667 91.9333 93.2 89.2 104 89.2C114.933 89.2 124.067 91.9333 131.4 97.4C138.867 102.733 144.467 110.733 148.2 121.4C151.933 132.067 153.8 145.333 153.8 161.2C153.8 176.8 151.867 190 148 200.8C144.267 211.6 138.733 219.8 131.4 225.4C124.067 231 114.933 233.8 104 233.8ZM104 218C114.667 218 122.6 213.4 127.8 204.2C133 195 135.6 180.667 135.6 161.2C135.6 141.733 133 127.533 127.8 118.6C122.733 109.533 114.8 105 104 105C93.3333 105 85.4 109.533 80.2 118.6C75 127.533 72.4 141.733 72.4 161.2C72.4 180.667 75 195 80.2 204.2C85.4 213.4 93.3333 218 104 218Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_4",
    x1: 17.5708,
    y1: 245.5,
    x2: 185.542,
    y2: 57.4119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.640288,
    stopColor: "#1890FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005FCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7_4",
    x1: 17.5708,
    y1: 245.5,
    x2: 185.542,
    y2: 57.4119,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.640288,
    stopColor: "#1890FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005FCC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo02);
export default __webpack_public_path__ + "static/media/logo02.5ec2a43505193e6716297e93aee49f3c.svg";
export { ForwardRef as ReactComponent };